<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/client-portal-and-billing-software.mjs";
</script>
